import { defineComponent, ref, onMounted, computed, } from '@vue/composition-api';
import { getSurveysList, } from '@/api/v2/requests/surveys';
import TableLoader from '@/views/_components/Table/TableLoader.vue';
import SurveyHeader from '@/views/Brand/Surveys/Users/_components/SurveyHeader.vue';
import SurveyUsersList from '@/views/Brand/Surveys/Users/_components/SurveyUsersList.vue';
import SurveyUsersAnswersList from '@/views/Brand/Surveys/Users/_components/SurveyUsersAnswersList.vue';
import SlotTabs from '@/components/Tabs/SlotTabs.vue';
const SURVEY_USER_TABS = {
    USERS: 'users',
    ANSWERS: 'answers',
};
export default defineComponent({
    name: 'SurveyUsers',
    components: {
        TableLoader,
        SurveyHeader,
        SurveyUsersList,
        SurveyUsersAnswersList,
        SlotTabs,
    },
    setup(_, ctx) {
        const isLoading = ref(false);
        const survey = ref(null);
        const activeTab = ref(SURVEY_USER_TABS.USERS);
        const surveyId = computed(() => ctx.root.$route.params.surveyId);
        const tabs = computed(() => ({
            [SURVEY_USER_TABS.USERS]: {
                name: SURVEY_USER_TABS.USERS,
                label: ctx.root.$t('brand-surveys.details.tabs.users').toString(),
            },
            [SURVEY_USER_TABS.ANSWERS]: {
                name: SURVEY_USER_TABS.ANSWERS,
                label: ctx.root.$t('brand-surveys.details.tabs.answers').toString(),
            },
        }));
        const selectTab = (tab) => {
            activeTab.value = tab.name;
        };
        const fetchSurvey = async () => {
            if (!surveyId.value)
                return;
            isLoading.value = true;
            try {
                const result = await getSurveysList({
                    ids: [surveyId.value],
                    perPage: 1,
                    page: 1,
                });
                if (result.nodes.length > 0) {
                    survey.value = result.nodes[0];
                }
                else {
                    survey.value = null;
                }
            }
            catch (error) {
                ctx.root.$toast.error(ctx.root.$t('brand-surveys.details.error-fetching'));
            }
            finally {
                isLoading.value = false;
            }
        };
        onMounted(() => {
            fetchSurvey();
        });
        return {
            isLoading,
            survey,
            activeTab,
            tabs,
            selectTab,
            SURVEY_USER_TABS,
        };
    },
});
